const MODULE_NAME = "LEGALS_";
const SHOW_DIALOG = MODULE_NAME + "SHOW_DIALOG";
const HIDE_DIALOG = MODULE_NAME + "HIDE_DIALOG";
const LEGAL_TYPE_AVV = "avv";
const LEGAL_TYPE_TOS = "tos";
const LEGAL_TYPE_PRIVACY = "privacy";

export {
  SHOW_DIALOG,
  HIDE_DIALOG,

  LEGAL_TYPE_AVV,
  LEGAL_TYPE_PRIVACY,
  LEGAL_TYPE_TOS
};
